export const ROUTES = {
  Auth: {
    Root: "auth",
    SignIn: "sign-in",
    SignUp: "sign-up",
    VerifyEmail: "verify-email",
    VerifyLogin: "verify-login",
    ExpiredVerification: "expired-verification",
    OAuthCallback: "callback",
  },

  Dashboard: {
    Root: "dashboard",
    MergeSpecs: "merge-specs",
    Inbox: {
      Root: "inbox",
    },
    MySpecs: {
      Root: "my-specs",
    },
    Specification: {
      Root: "specification",
      List: "specification/list",
      Templates: "specification/templates",
      Create: "specification/create",
      ProductAnswers: "specification/product-answers",
      CompareDetail: "specification/product-compare",
      Report: "specification/report",
      SupplierResponses: "specification/supplier-responses",
      SupplierResponsesAll: "specification/supplier-responses-all",
      Explore: "specification/explore",
      Skip: "specification/skip",
      ProductDiscovery: "specification/product-discovery",
      ProductDiscoverySingleCreate: "specification/product-discovery/create",
      ProductAnswersInvite: "specification/product-answers/invite",
      Regard: "specification/product-answers/thank-you",
    },
    Setting: {
      Root: "settings",
      MyProfile: "settings/my-profile",
      CompanyInfo: "settings/company-info",
      Integrations: "settings/integrations",
      Members: "settings/members",
      MemberDetail: "settings/member-detail",
      SecurityAccess: "settings/security-access",
      PlansAndBillings: "settings/plans-and-billings",
      Workspace: {
        Root: "settings/workspace",
        Create: "settings/workspace/create",
        SwitchLoading: "settings/workspace/switch-loading",
        MyWorkspaces: "settings/workspace/my-workspaces",
      },
    },
  },
  PrivacyPolicy: "privacy-policy",
  TermsOfService: "terms-of-service",
  Home: "/",
} as const;
